var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSimplify = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5042 4H15.24C13.8681 3.99805 12.6132 4.77258 12 5.9998V5.9998C11.3868 4.77258 10.1319 3.99805 8.76 4L4.4994 4.0004V4.0004C4.10173 4.0004 3.72035 4.15837 3.43916 4.43956C3.15797 4.72076 3 5.10214 3 5.4998V17.5008V17.5008C3 17.8985 3.15797 18.2799 3.43916 18.561C3.72035 18.8422 4.10173 19.0002 4.4994 19.0002H8.76C10.1319 18.9982 11.3868 19.7728 12 21V21C12.6132 19.7728 13.8681 18.9982 15.24 19.0002H19.5C20.3284 19.0002 21 18.3286 21 17.5002V5.4998C21 5.10214 20.842 4.72076 20.5608 4.43956C20.2796 4.15837 19.8983 4.0004 19.5006 4.0004V4.0004",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V21",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSimplify);
export default ForwardRef;